import { useLocation, useNavigate } from 'react-router-dom';
import { AuthShell } from './AuthShell';
import { Alert } from '@/components/ui/Alert';
import { Button } from '@/components/ui/Button';

// /auth/error — dead end for sign-in failures. AuthCallbackPage
// navigates here on OAuth errors (state mismatch, expired code,
// /api/me 403), and RequireAuth navigates here when
// redirectToHostedUi itself fails (popup-blocker corner cases, IdP
// unreachable). "Try again" pushes / which lands inside AppShell —
// no token → RequireAuth re-runs the IdP redirect.

interface ErrorState {
    message?: string;
}

export function AuthErrorPage() {
    const location = useLocation();
    const navigate = useNavigate();
    const message = (location.state as ErrorState | null)?.message
        ?? 'Sign-in could not be completed.';

    return (
        <AuthShell>
            <div className="space-y-4">
                <h1 className="text-2xl font-semibold text-text">Sign-in failed</h1>
                <Alert variant="danger">{message}</Alert>
                <Button
                    type="button"
                    className="w-full"
                    onClick={() => navigate('/', { replace: true })}
                >
                    Try again
                </Button>
            </div>
        </AuthShell>
    );
}
